<template>
  <label
    :class="[
      ns.b('button'),
      ns.is('active', modelValue === label),
      ns.is('disabled', disabled),
      ns.is('focus', focus),
      ns.bm('button', size),
    ]"
    data-component-name="Radio"
    :data-event-name="trackEventName"
    :data-event-content="trackEventContent"
  >
    <input
      ref="radioRef"
      v-model="modelValue"
      :class="ns.be('button', 'original-radio')"
      :value="label"
      type="radio"
      :name="name || radioGroup?.name"
      :disabled="disabled"
      @focus="focus = true"
      @blur="handleBlur"
      @click.stop
    />
    <span
      :class="ns.be('button', 'inner')"
      :style="modelValue === label ? activeStyle : {}"
      @keydown.stop
    >
      <!-- <div
        v-if="radioGroup?.angleBracket"
        :class="ns.bm('button', 'angle-bracket')"
      /> -->
      <slot>
        {{ label }}
      </slot>
    </span>
  </label>
</template>

<script lang="ts" setup>
import { computed, useSlots } from 'vue'
import { useNamespace } from '@jdesign-vue/hooks'
import { useRadio } from './use-radio'
import { radioButtonProps } from './radio-button'
import type { CSSProperties } from 'vue'

defineOptions({
  name: 'JdRadioButton',
})

const emit = defineEmits(['blur'])
const props = defineProps(radioButtonProps)

const ns = useNamespace('radio')
const slots = useSlots()
const { radioRef, focus, size, disabled, modelValue, radioGroup } =
  useRadio(props)

function getNodeText(node: any): string {
  if (node == null) return ''
  if (typeof node === 'string' || typeof node === 'number') return String(node)
  if (Array.isArray(node)) return node.map(getNodeText).join('')
  return getNodeText(node.children)
}

const trackText = computed(() => {
  const text = getNodeText(slots.default?.() ?? []).trim()
  if (text) return text
  if (props.label != null) return String(props.label)
  return '单选框'
})

const isChecked = computed(() => modelValue.value === props.label)

const trackEventName = computed(() =>
  isChecked.value ? 'unchecked' : 'checked'
)

const trackEventContent = computed(() =>
  `${isChecked.value ? '取消选中' : '选中'}${trackText.value}`
)

const activeStyle = computed<CSSProperties>(() => {
  return {
    backgroundColor: radioGroup?.fill || '',
    borderColor: radioGroup?.fill || '',
    boxShadow: radioGroup?.fill ? `-1px 0 0 0 ${radioGroup.fill}` : '',
    color: radioGroup?.textColor || '',
  }
})

const handleBlur = () => {
  focus.value = false
  emit('blur')
}
</script>
